import { get } from 'env-var';
import logger from 'helpers/logger';

let LOG_TO_DISK: boolean;
let NEXT_PUBLIC_LOG_TO_CONSOLE: boolean;
let NODE_ENV: string;
let ROBOTS_TXT_DISALLOW_ALL: boolean;
let WEBSITE_SSG_URL: string;
// Variables for logging in Seq
let SEQ_LOG: boolean;
let SEQ_URL: string;
let SEQ_ROLE: string;
let SEQ_SYSTEM: string;
let LOG_FILE_FOLDER: string;
let ISR_CACHE_SECRET: string;
let LOG_LEVEL: string;

// Check serverside at build time
if (typeof window === 'undefined') {
	LOG_TO_DISK = get('LOG_TO_DISK').required().asBoolStrict();
	LOG_FILE_FOLDER = get('LOG_FILE_FOLDER').required().asString();
	NEXT_PUBLIC_LOG_TO_CONSOLE = get('NEXT_PUBLIC_LOG_TO_CONSOLE').required().asBoolStrict();
	NODE_ENV = get('NODE_ENV').required().asString();
	ROBOTS_TXT_DISALLOW_ALL = get('ROBOTS_TXT_DISALLOW_ALL').default('false').asBool();
	WEBSITE_SSG_URL = get('WEBSITE_SSG_URL').required().asUrlString();
	SEQ_LOG = get('SEQ_LOG').required().asBoolStrict();
	SEQ_URL = get('SEQ_URL').required().asUrlString();
	SEQ_ROLE = get('SEQ_ROLE').required().asString();
	SEQ_SYSTEM = get('SEQ_SYSTEM').required().asString();
	ISR_CACHE_SECRET = get('ISR_CACHE_SECRET').required().asString() || 'placeholder';
	LOG_LEVEL = get('LOG_LEVEL').required().asString();
} else {
	try {
		NODE_ENV = process.env.NODE_ENV;
		if (typeof NODE_ENV === 'undefined') {
			logger.error('Reference error - NODE_ENV is undefined');
		}
	} catch (error) {
		logger.error(error);
		throw error;
	}
}

export {
	WEBSITE_SSG_URL,
	LOG_TO_DISK,
	NEXT_PUBLIC_LOG_TO_CONSOLE,
	NODE_ENV,
	ROBOTS_TXT_DISALLOW_ALL,
	LOG_FILE_FOLDER,
	SEQ_LOG,
	SEQ_URL,
	SEQ_ROLE,
	SEQ_SYSTEM,
	ISR_CACHE_SECRET,
	LOG_LEVEL,
};
